import React from 'react';
import {Box, Image, Layout, View, useDevice} from '@lookiero/aurora';

import {SectionLink} from '@views/_components';
import {style} from './JoinIn.styles';
import {Platform} from 'react-native';

interface JoinInProps {
  children: React.ReactNode;
  elementToScroll?: string;
  image: {src: string; srcSet: string};
  showImageOnMobile?: boolean;
}

const imageContainerStyle = Platform.OS !== 'web' ? style.imageContainerNative : style.imageContainerMobile;

export const JoinIn: React.FC<JoinInProps> = ({children, elementToScroll, image, showImageOnMobile = false}) => {
  const {screen} = useDevice();

  return (
    <View as="section" testID={'joinin-element'} style={screen.L ? style.containerL : style.containerS}>
      <Layout as="section" fullWidth={screen.L} style={style.detailLayout} wide>
        <Box size={{L: '2/3'}} style={screen.L && style.detailWrapper}>
          {children}
        </Box>
        {screen.L && elementToScroll && <SectionLink {...{elementToScroll}} />}
      </Layout>
      {screen.L && (
        <View style={style.imageContainer} testID="join-in-image">
          <Image resizeMode="cover" style={style.image} {...image} />
        </View>
      )}
      {!screen.L && showImageOnMobile && (
        <View style={imageContainerStyle} testID={'image-container'}>
          <Image style={style.image} resizeMode="cover" {...image} />
        </View>
      )}
    </View>
  );
};
